import z from "zod";
import { guardArray } from "../../../array";
import { getUserSchema } from "./get-user.schema";

export const getSubstitutionPlanCollisionParamSchema = z
	.object({
		absenceId: z.string(),
	})
	.and(getUserSchema);

export const getSubstitutionPlanCollisionQuerySchema = z.object({
	assignedUserIds: z
		.any()
		.transform((val) => {
			return guardArray(val);
		})
		.pipe(z.array(z.string())),
	startDate: z.string(),
	endDate: z.string(),
});

export type GetSubstitutionPlanCollisionQuerySchema = z.infer<
	typeof getSubstitutionPlanCollisionQuerySchema
>;
export type GetSubstitutionPlanCollisionParamSchema = z.infer<
	typeof getSubstitutionPlanCollisionParamSchema
>;
